package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.WhiteboardAction
import fr.manyverse.app.domain.repository.WhiteboardRepository

class GetWhiteboardActionsUseCase(
    private val whiteboardRepository: WhiteboardRepository
) {
    suspend operator fun invoke(whiteboardId: String): Result<List<WhiteboardAction>> {
        return whiteboardRepository.getWhiteboardActions(whiteboardId)
    }
}
